import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LANDING_ROUTE, USER } from '../app-data';
import { LocalStorageService } from '../shared/services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class UnAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const currUser: USER = this.localStorageService.getUser();
    if (!currUser) {
      return true;
    } if (currUser && currUser.role) {
      return this.router.parseUrl(LANDING_ROUTE[currUser.role as keyof typeof LANDING_ROUTE]);
    } else {
      this.localStorageService.logoutUser();
      return this.router.parseUrl(LANDING_ROUTE['guest']);
    }
  }

}
